import PrimaryTable from "../../components/Table/PrimaryTable"
import useApprovalColumns from "../../components/TableHeader/ApprovalColumns";
import { useGetApproveMutation } from "../../features/approval/approveApi";
import { useDispatch, useSelector } from "react-redux";
import { setApprove, setApproveLoading } from "../../features/approval/approveSlice";
import { Box } from "@mui/material";

const ApprovedCase = ({leadData}) => {

    const dispatch = useDispatch();
    
    const { approve, totalRowCount, isApproveLoading } = useSelector((state) => state.approve);

    const columns = useApprovalColumns();
    

    const [getApproveCase] = useGetApproveMutation();

    const fetchData = async ({ pagination, sorting, columnFilters, globalFilter }) => {
            dispatch(setApproveLoading(true));
            try {
              const res = await getApproveCase({
                pageIndex: pagination.pageIndex,
                pageSize: pagination.pageSize,
                sorting,
                columnFilters,
                globalFilter,
                data: {
                  customerID: leadData?.customerID,leadID: leadData?.leadID,DB: leadData?.TAG
                },
              }).unwrap();
        
              dispatch(setApprove({ data: res?.data, totalRowCount: res?.data?.totalRowCount })); // Adjust if backend sends total count separately
            } catch (error) {
            } finally {
              dispatch(setApproveLoading(false));
            }
    };

    return (
        <>
     
               <PrimaryTable
                                                             columns={columns}
                                                             data={approve}
                                                             isLoading={isApproveLoading}
                                                             totalRowCount={totalRowCount}
                                                             fetchData={fetchData}
                />
        </>
    )

}


export default ApprovedCase
